import { React } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../../Context/LanguageContext';

import TopBar from './TopBar';
import LocationButton from './LocationButton';

function PrivacyModel() {
  const { t } = useLanguage();

  return (
    <TopLevelWrapper>
      <TopBar />
      <BottomWrapper>
        <LocationButton nowPage={'Privacy'} />
        <TextWrapper>
          <Title style={{ marginTop: `38px` }}>{t('rules.privacy.t1')}</Title>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.privacy.p1')}
          </Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.privacy.t2')}</Title>
          <Text>
            {t('rules.privacy.p2')}
          </Text>

          <Bold style={{ marginTop: `14px` }}>{t('rules.privacy.b1')}</Bold>
          <Text>
            {t('rules.privacy.p3')}
          </Text>
          <Text style={{ marginTop: `14px`}}>
            {t('rules.privacy.p4')}
          </Text>

          <Bold style={{ marginTop: `14px`}}>{t('rules.privacy.b2')}</Bold>
          <Text>
            {t('rules.privacy.p5')}
          </Text>
          <Text>
            {t('rules.privacy.p6')}
          </Text>
          <Text>
            {t('rules.privacy.p7')}
          </Text>
          <Bold>
            {t('rules.privacy.b3')}
          </Bold>

          <Title style={{ marginTop: `38px` }}>{t('rules.privacy.t3')}</Title>
          <Text>
            {t('rules.privacy.p8')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.privacy.p9')}
          </Text>
          <Text style={{ marginTop: `14px` }}>
            {t('rules.privacy.p10')}
          </Text>
          <Text>
            {t('rules.privacy.p11')}
          </Text>
          <Text>
            {t('rules.privacy.p12')}
          </Text>
          <Text>
            {t('rules.privacy.p13')}
          </Text>
          <Text>
            {t('rules.privacy.p14')}
          </Text>
          <Text>
            {t('rules.privacy.p15')}
          </Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.privacy.t4')}</Title>
          <Text>
            {t('rules.privacy.p16')}
          </Text>
          <Text>
            {t('rules.privacy.p17')}
          </Text>
          <Text>
            {t('rules.privacy.p18')}
          </Text>
          <Text>
            {t('rules.privacy.p19')}
          </Text>
          <Text>
            {t('rules.privacy.p20')}
          </Text>
          <Text>
            {t('rules.privacy.p21')}
          </Text>
          <Text>
            {t('rules.privacy.p22')}
          </Text>
          <Text>
            {t('rules.privacy.p23')}
          </Text>

          <Bold style={{ marginTop: `14px` }}>{t('rules.privacy.b4')}</Bold>

          <Text style={{ marginTop: `14px` }}>
            {t('rules.privacy.p24')}
          </Text>
          <Text>
            {t('rules.privacy.p25')}
          </Text>
          <Text>
            {t('rules.privacy.p26')}
          </Text>

          <Text style={{ marginTop: `14px` }}>
            {t('rules.privacy.p27')}
          </Text>

          <Title style={{ marginTop: `38px` }}>
            {t('rules.privacy.t5')}
          </Title>
          <Text style={{ marginBottom: `96px` }}>
            {t('rules.privacy.p28')}
          </Text>
        </TextWrapper>
      </BottomWrapper>
    </TopLevelWrapper>
  )
}

export default PrivacyModel;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  background-color: ${props => props.theme.background};
`;

const BottomWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 1194px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: ${props => props.theme.primary};

  margin: 0 0 0 0;
`;

const Bold = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;
